import React, { useState } from 'react';
const api= {
    key: "1d4a7dbf6b5c5b791a62d26c263949f0",
    base: "https://api.openweathermap.org/data/2.5/"
}


function App() {
    const [query, setQuery] = useState('');
    const [weather, setWeather] = useState({});

    const search = evt => {
        if (evt.key === "Enter") {
            fetch (`${api.base}weather?q=${query}&units=metric&APPID=${api.key}`)
            .then(res => res.json())
            .then(result => {
                setWeather(result);
                setQuery('');
            });
        }
    }

const dateBuilder = (d) => {
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    
    let day = days[d.getDay()];
    let month = months[d.getMonth()];
    let date = d.getDate();
    let year = d.getFullYear();

    return `${day}, ${month} ${date} ${year}`
}

    return (
        <div className={
            (typeof weather.main != "undefined")
            ? ((weather.main.temp > 15)
            ? 'app warm'
            : 'app')
            : 'app'}>
            <main>
                <div className="header">
                    <h1>
                        <span role="img" aria-label="Snowflake">❄️</span>
                        Welcome to Weather App
                        <span role="img" aria-label="Sun With Smiling Face">🌞</span></h1>
                    <br></br>
                    <h2>To begin, type in the name of your city in the box below to show the current weather condition.</h2>
                </div>
                <div className="search-box">
                    <input 
                    type="text"
                    className="search-bar"
                    placeholder="Search..."
                    onChange={e => setQuery(e.target.value)}
                    value={query}
                    onKeyPress={search}
                    />
                </div>
                {(typeof weather.main != "undefined") ? (
                <div>
                    <div className="location-box">
                        <div className="location">{weather.name}, {weather.sys.country}</div>
                        <div className="date">{dateBuilder(new Date())}</div>
                    </div>
                    <div className="weather-box">
                        <div className="temp">
                        {Math.round(weather.main.temp)}°C
                        </div>
                        <div className="weather">
                        {weather.weather[0].main}</div>
                    </div>
                </div>
                ) : ('')}
            </main>
        </div>
    );
}

export default App;